// extracted by mini-css-extract-plugin
module.exports = {"root":"WaitListForm_root__1oR3F","configContainer":"WaitListForm_configContainer__2eBzk","validationMsg":"WaitListForm_validationMsg__1v_sW"};